/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Display from './Display/index'
import Edit from './Edit/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content"
  
}) {
  return (<React.Fragment
>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<Display
  viewPath={`${viewPath}/Display`}
/>
{children}
</React.Fragment>)
}